import { Toast } from 'react-hot-toast';

export const computeRemainingFraction = (
  toast: Toast,
  pausedAt: number | undefined
): number => {
  if (!toast.duration || toast.duration === Infinity) return 1;
  const now = pausedAt ?? Date.now();
  const elapsed = now - toast.createdAt - toast.pauseDuration;
  return Math.min(1, Math.max(0, 1 - elapsed / toast.duration));
};
